import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { guid } from '@datorama/akita';
import { FacetOption, FilterService } from '@lobos/library';

@Component({
  selector: 'app-facet-option',
  templateUrl: './facet-option.component.html',
  styleUrls: ['./facet-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacetOptionComponent {
  /** observable facet option (value) */
  @Input() option!: FacetOption;

  /** the facet name */
  @Input() facetName!: string;

  @Output() facetChanged = new EventEmitter<FacetOption>();

  /** holds the guid for the checkbox id and label for */
  checkboxId: string;

  constructor(private filterService: FilterService) {
    this.checkboxId = guid();
  }

  /**
   * toggles the filter chebox and the corresponding filter in the store and query params
   * @param filter
   */
  toggleFilter(filter: FacetOption): void {
    this.facetChanged.emit(filter);

    if (filter.isActive) {
      this.filterService.removeFilterWithParam(filter.key, this.facetName);
    } else {
      this.filterService.setFilter({
        id: this.checkboxId,
        name: this.facetName,
        value: filter.key,
        order: 1,
      });
    }
  }
}
